<template>
    <div class="form-row">
        <vue-skeleton-loader
            type="rec"
            :width="1100"
            :height="446"
            animation="fade"
        />
    </div>
</template>
<script>
import VueSkeletonLoader from 'skeleton-loader-vue';

export default {
  name: "ChartCriteriaSkeleton",
  mixins: [],
  components: {VueSkeletonLoader},
  data() {
    return {};
  },    
  props: {},
  methods: {},
  computed: {}, 
  created() {},
  mounted() {},
};

</script>